/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Empty, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import utils from '../common/utils';
import LoadingComponent from './common/LoadingComponent';
import consts from '../consts';

function UserLoginHistoryComponent(props) {
  const { t, i18n } = useTranslation();
  // state
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [dataTableLoginHistory, setDataTableLoginHistory] = useState([]);

  // useEffect
  useEffect(() => {
    props.getUserLoginHistory({ pos: 0, count: 10 }, (dataTable, totCount) => { setDataTableLoginHistory(dataTable); setTotalCount(totCount); });
  }, []);

  // variable
  const columns = () => [
    {
      title: 'Pubkey',
      // width: '20%',
      dataIndex: 'pubkey',
      key: 'pubkey',
      ellipsis: true,
      // render: (value) => <div title={value} >{value}</div>,
    },
    {
      title: t('user.login_history.agent_title'),
      // width: '20%',
      dataIndex: 'agent',
      key: 'agent',
      ellipsis: true,
      // render: (value) => <div title={value} >{value}</div>,
    },
    {
      align: 'center',
      title: 'IP',
      width: 170,
      dataIndex: 'ip',
      key: 'ip',
    },
    {
      align: 'center',
      title: t('user.login_history.login_time_title'),
      width: 200,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => (
        <div>
          {utils.formatTimeFromUnix(text, 'DD/MM/YY HH:mm:ss')}
        </div>
      ),
    },
  ];

  return (
    <div className="depositandwithdrawal p-medium user-wallet">
      {/* <h1 className='text-white text-left'>{t('user.order_tran.title')}</h1> */}
      <div className="depositandwithdrawal-top">
        <Table
          columns={columns()}
          dataSource={[...dataTableLoginHistory]}
          pagination={{
            showQuickJumper: true,
            current: currentPage,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              props.getUserLoginHistory(
                {
                  pos: (page - 1) * pageSize,
                  count: pageSize,
                },
                (dataTable, totCount) => { setDataTableLoginHistory(dataTable); setTotalCount(totCount); },
              );
            },
            defaultPageSize: 10,
            total: totalCount,
            hideOnSinglePage: true,
          }}
          className="mb-large"
        />
      </div>
    </div>
  );
}

export default UserLoginHistoryComponent;
